/**
 * PostHog Analytics Event Names
 * Centralized constants for all tracking events
 */

export const KYB_ACCOUNT_TYPE = {
  FREELANCER: 'frl',
  CORPORATE_NON_FI: 'cnf',
  CORPORATE_FI: 'cfi'
};

export const ANALYTICS_EVENTS = {
  // Payment Links - Page & Navigation
  PAYMENT_LINKS_PAGE_VIEWED: 'payment_links_page_viewed',
  CREATE_LINK_VIEWED: 'create_link_viewed',
  PAYMENT_LINK_VIEW_CLICKED: 'payment_link_view_clicked',

  // Payment Links - CTA Actions
  ADD_PAYMENT_LINK_CLICKED: 'add_payment_link_clicked',
  PAYMENT_LINK_COPIED: 'payment_link_copied',
  PAYMENT_LINK_DELETE_CLICKED: 'payment_link_delete_clicked',
  PAYMENT_LINK_DOWNLOAD_QR_CODE_CLICKED: 'payment_link_download_qr_code_clicked',

  // Payment Links - Form Interactions
  NEW_PAYMENT_LINK_NAME_ENTERED: 'new_payment_link_name_entered',
  NEW_PAYMENT_LINK_AMOUNT_ENTERED: 'new_payment_link_amount_entered',
  NEW_PAYMENT_LINK_CURRENCY_SELECTED: 'new_payment_link_currency_selected',
  NEW_PAYMENT_LINK_FORM_SUBMITTED: 'new_payment_link_form_submitted',

  // Payment Links - Post-Creation
  PAYMENT_LINK_QR_CODE_VIEWED: 'payment_link_qr_code_viewed',

  // Signup + Email Verification
  SIGNUP_INITIATED: 'signup_initiated',
  SIGNUP_PAGE_VIEWED: 'signup_page_viewed',
  SIGNUP_FORM_STARTED: 'signup_form_started',
  SIGNUP_SUBMITTED: 'signup_submitted',
  EMAIL_VERIFICATION_VIEWED: 'email_verification_viewed',
  EMAIL_CODE_ENTERED: 'email_code_entered',
  VERIFY_EMAIL_CLICKED: 'verify_email_clicked',
  EMAIL_CODE_RESENT: 'email_code_resent',
  ACCOUNT_CREATION_SUCCESS_MODAL_VIEWED: 'account_creation_success_modal_viewed',

  // Onboarding Navigation
  ONBOARDING_TAB_CLICKED: 'onboarding_tab_clicked',
  KYB_OVERVIEW_VIEWED: 'kyb_overview_viewed',
  KYB_START_CLICKED: 'kyb_start_clicked',

  // KYB Basic/Business Details
  KYB_BASIC_INFO_VIEWED: 'kyb_basic_info_viewed',
  KYB_BASIC_INFO_STARTED: 'kyb_basic_info_started',
  KYB_BASIC_INFO_SAVED: 'kyb_basic_info_saved',

  // KYB Business Documents
  KYB_DOCUMENT_PAGE_VIEWED: 'kyb_document_page_viewed',
  KYB_DOC_UPLOADED: 'kyb_doc_uploaded',
  KYB_DOC_DELETED: 'kyb_doc_deleted',
  KYB_DOC_VIEWED: 'kyb_doc_viewed',
  KYB_DOCS_CONFIRMED: 'kyb_docs_confirmed',
  KYB_AML_POLICY_UPLOADED: 'kyb_AML_policy_uploaded',
  CFI_SCUML_UPLOADED: 'cfi_scuml_uploaded',
  KYB_SUBMIT_CLICKED: 'kyb_submit_clicked',

  // KYB Corporate - Ownership
  KYB_OWNERS_VIEWED: 'kyb_owners_viewed',
  KYB_DIRECTOR_ADDED: 'kyb_director_added',
  KYB_DIRECTOR_REMOVED: 'kyb_director_removed',
  KYB_DIRECTORS_FILE_UPLOADED: 'kyb_directors_file_uploaded',
  KYB_SHAREHOLDER_ADDED: 'kyb_shareholder_added',
  KYB_SHAREHOLDER_REMOVED: 'kyb_shareholder_removed',
  KYB_SHAREHOLDERS_FILE_UPLOADED: 'kyb_shareholders_file_uploaded',
  KYB_UBO_ADDED: 'kyb_ubo_added',
  KYB_UBO_REMOVED: 'kyb_ubo_removed',
  KYB_UBO_ID_UPLOADED: 'kyb_ubo_id_uploaded',
  KYB_OWNERS_SAVED: 'kyb_owners_saved',

  // KYB Corporate - PEP
  KYB_PEP_VIEWED: 'kyb_pep_viewed',
  KYB_PEP_ENTRY_ADDED: 'kyb_pep_entry_added',
  KYB_PEP_ENTRY_REMOVED: 'kyb_pep_entry_removed',
  KYB_PEP_SAVED: 'kyb_pep_saved',

  // KYB Corporate - Due Diligence
  KYB_DD_VIEWED: 'kyb_dd_viewed',
  CFI_DD_INFO_ADDED: 'cfi_dd_info_added',
  CFI_DD_SAVED: 'cfi_dd_saved'
};
